export type TCookieCategory =
  | 'necessary'
  | 'functional'
  | 'analytics'
  | 'advertisement';

export type TConsentableCategory = Exclude<TCookieCategory, 'necessary'>;

export const CONSENT_COOKIE_NAME: string = 'vitay_cookie_consent';
export const CONSENT_VERSION: number = 1;
export const CONSENT_EXPIRY_DAYS: number = 365;

export const CONSENTABLE_CATEGORIES: TConsentableCategory[] = [
  'functional',
  'analytics',
  'advertisement'
];

export interface IConsentState {
  version: number;
  updatedAt: string;
  categories: Record<TConsentableCategory, boolean>;
}

export interface ICookieDeclaration {
  name: string;
  provider: string;
  category: TCookieCategory;
  purposeKey: string;
  duration: string;
  // 'script' declares a third-party script that stores nothing client-side
  // but does send the visitor's IP address to its provider when loaded.
  type: 'cookie' | 'localStorage' | 'sessionStorage' | 'script';
}
